// Single source of truth for "which routes may this user see?".
//
// Both App.jsx (which registers the <Route> elements) and the sidebar (which
// renders the menu) need this answer, and they must agree: a route in the menu
// but not registered would 404 on click. They previously filtered separately
// and had already drifted.
//
// There is no environment dimension here on purpose. Every environment runs the
// same route table; to hide a view, comment out its entry in routes.js.
export function isRouteAllowed(route, user) {
  if (route.tenants && !(user?.tenant && route.tenants.includes(user.tenant))) return false;
  if (route.roles && !(user?.role && route.roles.includes(user.role))) return false;
  return true;
}

// Routes the user may reach in an area, e.g. "app" or "auth".
export function getAllowedRoutes(routes, area, user) {
  return routes.filter((r) => r.area === area && isRouteAllowed(r, user));
}

// Subset that should also appear in the sidebar.
export function getSidebarRoutes(routes, area, user) {
  return getAllowedRoutes(routes, area, user).filter((r) => r.sidebar !== false);
}
